<script lang="ts">
	import type { ContextMenuProps } from '$lib_commons/models/context-menu.ts'
	import { ContextMenu } from '@repo/commons/components'

	type Props = {
		contextMenuProps: ContextMenuProps | null
	}

	let { contextMenuProps }: Props = $props()
</script>

{#if contextMenuProps && contextMenuProps.items.length > 0}
	<ContextMenu x={contextMenuProps.x} y={contextMenuProps.y} items={contextMenuProps.items} />
{/if}
